import React from "react";
import PageHero from "../components/shared/PageHero";
import AboutStats from "../components/about/AboutStats";
import FourPillars from "../components/about/FourPillars";
import BuiltByPeople from "../components/about/BuiltByPeople";
import JoinCultureCta from "../components/about/JoinCultureCta";

export default function About() {
  return (
    <>
      <PageHero
        eyebrow="Our Story"
        title="Where Music, Culture & Creativity Come Alive"
        subtitle="MusicUntamed exists to remove the gatekeepers between African artists and the world — giving musicians the tools to create, distribute, and grow, while giving fans a direct line to the sound and culture shaping the continent."
      />
      <AboutStats />
      <FourPillars />
      <BuiltByPeople />
      <JoinCultureCta />
    </>
  );
}
